 <form class="wrapper" [formGroup]="form" *ngIf="currentStep === possibleSteps.EmailValidation" (submit)="validate()">
   <span class="text-color-black top-hint">{{'ADD_NEW_LOGIN_NOTE' | dictionary}}</span>
   <div class="inputs-wrapper">
     <div class="input-wrapper">
       <input #email formControlName="email" [placeholder]="'EMAIL_ADDRESS' | dictionary" [style.margin.px]="1" >
       <span class="hint-msg">{{'SEARCH_ADDRESS' | dictionary}}</span>
       <span class="asterisk error-msg"
             *ngIf="form.get('email').touched && form.get('email').hasError('required')">{{'PLEASE_ENTER_EMAIL' | dictionary}}</span>
       <span class="asterisk error-msg"
             *ngIf="form.get('email').touched && form.get('email').hasError('pattern')">{{'INVALID_FORMAT' | dictionary}}</span>
     </div>
   </div>


   <div class="actions-wrapper">
     <button (click)="validate()" type="submit" class="button-1">{{'VALIDATE' | dictionary}}</button>
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </form>

 <div class="wrapper" *ngIf="currentStep === possibleSteps.CanNotBeAdded">
   <span class="text-color-black top-hint">{{errorMessageText}}</span>

   <div class="actions-wrapper">
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </div>

 <div class="wrapper" *ngIf="currentStep === possibleSteps.HasAccess">
   <!-- <span class="text-color-black top-hint">{{'ACCOUNT_ALREADY_LINKED' | dictionary}}</span>  -->
   <span class="text-color-black top-hint">{{errorMessageText}}</span>

   <div class="info-wrapper">
     <div>
       <span class="sub-title">{{'EMAIL_ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundEmail}}</span>
     </div>

     <div>
       <span class="sub-title">{{'NAME' | dictionary}}:</span>
       <span>{{accountInfo.FoundName}}</span>
     </div>

     <div>
       <span class="sub-title">{{'ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundAddrLine1}}<br>{{accountInfo.FoundAddrLine2}}<br>{{accountInfo.FoundAddrLine3}}</span>
     </div>


   </div>

   <div class="actions-wrapper">
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </div>

 <div class="wrapper" *ngIf="currentStep === possibleSteps.GiveAccess">
   <span class="text-color-black top-hint">{{errorMessageText}}</span>

   <div class="info-wrapper">
     <div>
       <span class="sub-title">{{'EMAIL_ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundEmail}}</span>
     </div>

     <div>
       <span class="sub-title">{{'NAME' | dictionary}}:</span>
       <span>{{accountInfo.FoundName}}</span>
     </div>

     <div>
       <span class="sub-title">{{'ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundAddrLine1}}<br>{{accountInfo.FoundAddrLine2}}<br>{{accountInfo.FoundAddrLine3}}</span>
     </div>


   </div>

   <div class="actions-wrapper">
     <button (click)="link()" type="submit" class="button-1">{{'LINK_ACCOUNT' | dictionary}}</button>
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </div>

 <div class="wrapper" *ngIf="currentStep === possibleSteps.DupMailFound">
   <span class="text-color-black top-hint">{{errorMessageText}}</span>

   <div class="info-wrapper">
     <div>
       <span class="sub-title">{{'EMAIL_ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundEmail}}</span>
     </div>

     <div>
       <span class="sub-title">{{'NAME' | dictionary}}:</span>
       <span>{{accountInfo.FoundName}}</span>
     </div>

     <div>
       <span class="sub-title">{{'ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundAddrLine1}}<br>{{accountInfo.FoundAddrLine2}}<br>{{accountInfo.FoundAddrLine3}}</span>
     </div>


   </div>

   <div class="actions-wrapper">
     <button (click)="link()" type="submit" class="button-1">{{'LINK_ACCOUNT' | dictionary}}</button>
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </div>

 <div class="wrapper" *ngIf="currentStep === possibleSteps.LinkAccounts" (submit)="link()">
   <span
     class="text-color-black top-hint">{{'ACCOUNT_BY_EMAIL_FOUND' | dictionary : getAccountType(accountInfo.FoundRecordType)}}</span>

   <div class="info-wrapper">
     <div>
       <span class="sub-title">{{'EMAIL_ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundEmail}}</span>
     </div>

     <div>
       <span class="sub-title">{{'NAME' | dictionary}}:</span>
       <span>{{accountInfo.FoundName}}</span>
     </div>

     <div>
       <span class="sub-title">{{'ADDRESS' | dictionary}}:</span>
       <span>{{accountInfo.FoundAddrLine1}}<br>{{accountInfo.FoundAddrLine2}}<br>{{accountInfo.FoundAddrLine3}}</span>
     </div>


   </div>

   <span
     class="text-color-black top-hint"
     [style.marginTop.px]="16"> {{'WISH_TO_LINK_ACCOUNT' | dictionary : getAccountType(accountInfo.FoundRecordType)}}</span>


   <div class="actions-wrapper">
     <button (click)="link()" type="submit" class="button-1">{{'LINK_ACCOUNT' | dictionary}}</button>
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </div>

 <form class="wrapper" *ngIf="currentStep === possibleSteps.NotFound" (submit)="saveAccount()"
       [formGroup]="newAccountForm">
   <span
     class="text-color-black top-hint">{{'ENTER_INFO_TO_CREATE_ACCOUNT' | dictionary}}</span>
   <div class="inputs-wrapper new-account-form">

     <div class="field-wrapp">
       <div class="title">{{'EMAIL_ADDRESS' | dictionary}}</div>
       <div>
         <input formControlName="email" aria-describedby="emailHelp"/>
         <span class="asterisk error-msg"
               *ngIf="newAccountForm.get('email').touched && newAccountForm.get('email').hasError('required')">{{'PLEASE_ENTER_EMAIL' | dictionary}}</span>
         <span class="asterisk error-msg"
               *ngIf="newAccountForm.get('email').touched && newAccountForm.get('email').hasError('pattern')">{{'INVALID_FORMAT' | dictionary}}</span>
       </div>
     </div>

     <div class="field-wrapp">
       <div class="title">{{'NEW_USER_NAME' | dictionary}}</div>
       <div>
         <input formControlName="name"/>
         <span class="asterisk error-msg"
               *ngIf="newAccountForm.get('name').touched && newAccountForm.get('name').hasError('required')">{{'REQUIRED_FIELD' | dictionary}}</span>
       </div>
     </div>

     <div class="field-wrapp">
       <div class="title">{{'CURRENT_ADDRESS' | dictionary}}</div>
       <div>
         <input formControlName="line1"/>
       </div>
     </div>

     <div class="field-wrapp">
       <div class="title"></div>
       <div>
         <input formControlName="line2"/>
       </div>
     </div>

     <div class="field-wrapp">
       <div class="title"></div>
       <div>
         <input formControlName="line3"/>
       </div>
     </div>

     <div class="three-field-wrapp">
 <!--      <div class="gap-16"> -->
         <div class="title">{{'CITY' | dictionary}}</div>
         <div>
           <input formControlName="city"/>
           <span class="asterisk error-msg"
                 *ngIf="newAccountForm.get('city').touched && newAccountForm.get('city').hasError('required')">{{'REQUIRED_FIELD' | dictionary}}</span>
         </div>
 <!--      </div> -->

 <!--      <div class="gap-16"> -->
         <div class="title">{{'STATE' | dictionary}}</div>
         <div>
           <input formControlName="state"/>
           <span class="asterisk error-msg"
                 *ngIf="newAccountForm.get('state').touched && newAccountForm.get('state').hasError('required')">{{'REQUIRED_FIELD' | dictionary}}</span>
         </div>
 <!--      </div> -->

 <!--      <div class="gap-16"> -->
         <div class="title">{{'ZIP_CODE' | dictionary}}</div>
         <div>
           <input formControlName="zip"/>
           <span class="asterisk error-msg"
                 *ngIf="newAccountForm.get('zip').touched && newAccountForm.get('zip').hasError('required')">{{'REQUIRED_FIELD' | dictionary}}</span>
         </div>
 <!--      </div> -->

     </div>

     <div class="field-wrapp">
       <div class="title">{{'PHONE_NUMBER' | dictionary}}</div>
       <div>
         <input formControlName="phone"/>
       </div>
     </div>

   </div>


   <div class="actions-wrapper">
     <button (click)="saveAccount()" type="submit" class="button-1">{{'SAVE' | dictionary}}</button>
     <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
   </div>
 </form>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onClosePopup()">
 </app-pop-up-dialog>



